import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { setFieldError } from 'framework/forms/utils/setFieldError';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import * as yup from 'yup';
import { FormSelectOrCreateEntPhysicianField } from './FormSelectOrCreateEntPhysicianField';

interface IModel {
	id: string;
}

const createSchema = (strings: IStrings) => {
	return yup.object<IModel>({
		id: yup.string().required(strings.formRequired(strings.entPhysician)),
	});
};

interface IProps extends DialogProps {
	initialId?: string;
	confirm: (id: string, setError: (error: string) => void) => void;
	cancel: VoidFunction;
	isSubmitting: boolean;
	withSelectOffice?: boolean;
}

export const SelectEntPhysicianForm = ({ initialId, confirm, cancel, isSubmitting, withSelectOffice = false, ...rest }: IProps) => {
	const strings = useLocalization();
	const { isStacked } = useDialogsContext();

	const handleSubmit = (values: IModel, helpers: FormikHelpers<IModel>) => {
		confirm(values.id, (error: string) => setFieldError<IModel>('id', error, helpers));
	};

	return (
		<Formik<IModel>
			validateOnMount
			initialValues={{
				id: initialId ?? '',
			}}
			validationSchema={createSchema(strings)}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}
					open={rest.open && isStacked === false}>
					<DialogTitle>{strings.selectWhat(strings.entPhysician)}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'>
						<FormSelectOrCreateEntPhysicianField<IModel>
							name='id'
							label={strings.entPhysician}
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						cancel={cancel}
						isSubmitting={isSubmitting}
						submitText={strings.link}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
